<style lang="sass" scoped>
.charge
    padding: 20px
    .home-fee
        height: 120px
        padding: 20px
        border-radius: 10px
        margin-bottom: 20px
        background: linear-gradient(135deg,rgba(216,202,154,0.5) 0%,rgba(196,171,130,0.5) 100%)
        >img
            width: 80px
            height: 80px
            margin-right: 20px

        .center
            display: inline-block
            width: calc(100% - 100px)
            .each
                display: inline-block
                width: 33.333333%
                font-weight: 400
                height: 40px
                border-left: 1px solid #fff
                text-align: center
                font-size: 16px
                margin-top: 20px
                > span
                    position: relative
                    top: -5px
                div
                    font-size: 24px
                    font-weight: 800
                    .small
                        font-size: 18px
    .charge-main
        text-align: center
        border: 1px solid #e9e9e9
        border-radius: 10px 10px 0px 0px
        .fw
            font-weight: 550
        .main-tlt
            font-size: 18px
            font-family: PingFangSC-Semibold
            font-weight: 600
            color: rgba(40,39,41,1)
            line-height: 40px
            background: #F5F5F5
        .main-box
            // border: 1px solid #e9e9e9
            border-top: none
        .charge-row
            line-height: 60px
            overflow: hidden
            border-top: 1px solid #e9e9e9
            padding: 10px 0
            text-align: left
            .label
                font-weight: 400px
                width: 80px
                text-align: right
                margin-right: 20px
                float: left
            .fl
                position: relative
            .fee-box
                cursor: pointer
                width: 120px
                height: 60px
                border-radius: 4px
                border: 1px solid rgba(212,212,212,1)
                font-size: 20px
                display: inline-block
                margin-right: 10px
                color: #d4d4d4
                position: relative
                margin: 10px 20px 10px 0
                text-align: center
                &.pay-way
                    font-size: 14px
                    height: 40px
                    line-height: 40px
                &.cur
                    border: 1px solid #B39A70
                    color: #B39A70
                    &.pay-way
                        color: #282729
                    img
                        display: block
                img
                    display: none
                    position: absolute
                    right: 0
                    top: 0
                    width: 20px

.pay-money
    text-align: left
    span
        font-size: 20px
    i
        font-size: 16px
        margin-right: 3px

.submit-btn
    margin-left: 100px
    margin-top: 40px

.go-account
    background: rgba(255,57,115,.1)
    font-size: 16px
    border-radius: 4px
    margin: 10px 20px 0
    text-align: center
    span
        color: #FF3973
        cursor: pointer

.pay-fee
    font-size: 24px
    font-weight: bold
    span
        font-size: 14px
        font-weight: normal

.confirm-box
    padding: 11px
    text-align: center
    font-size: 16px
    div
        margin-bottom: 10px
    span
        display: inline-block
        font-size: 14px
        color: #999
        margin-top: 10px
</style>

<style lang="sass">
.charge-row
    .el-input
        width: 120px
        margin-right: 20px
        & + span
            color: #999
        input
            text-align: center
            font-size: 20px
            font-family: 'Akrobat-ExtraBold'
        &.has-value
            input
                color: #B39A70
                border: 1px solid #B39A70
</style>

<template lang="pug">
    div
        .p-title 充值
        .p-main
            .charge
                .home-fee
                    img.fl(src="../assets/home-icon-fee.png")
                    .center
                        .each
                            span 总余额
                            .els.Akrobat-ExtraBold
                                span.small ￥
                                span {{allFee | fmtFee}}
                                span.small .{{allFee | fmtFee(1)}}
                        .each
                            span 现金余额
                            .els.Akrobat-ExtraBold
                                span.small ￥
                                span {{cashFee | fmtFee}}
                                span.small .{{cashFee | fmtFee(1)}}
                        .each
                            span 赠款余额
                            .els.Akrobat-ExtraBold
                                span.small ￥
                                span {{giveFee | fmtFee}}
                                span.small .{{giveFee | fmtFee(1)}}

                .charge-main
                    .main-tlt 现金转账充值
                    .main-box
                        .charge-row
                            .label 充值账户
                            .fl.fw {{adUser.userName}}
                        .charge-row
                            .label(style="position:relative;top:10px;") 充值金额
                            .fl(style="width:calc(100% - 100px);text-align: left;")
                                .fee-box.Akrobat-ExtraBold(
                                    v-for="(item, i) in moneys" :key="i"
                                    :class="{'cur': curFeeTab == i}"
                                    @click="changeIdx('curFeeTab', i)"
                                ) ￥{{item}}
                                    img(src="../assets/charge-icon.png")
                        .charge-row(style="border-top: none;padding-top: 0;")
                            .label 其他金额
                            .fl
                                el-input.Akrobat-ExtraBold(
                                    v-model="inputFee" placeholder="￥"
                                    :class="{'has-value': inputFee}"
                                    @focus="inputFocus"
                                    @keyup.native="keyupAction"
                                )
                                span 请输入100以上的整数
                        .charge-row
                            .label 支付方式
                            .fl
                                .fee-box.pay-way(
                                    v-for="(item, i) in payWays" :key="i"
                                    :class="{'cur': curPayWay == i}"
                                    @click="changeIdx('curPayWay', i)"
                                ) {{item}}
                                    img(src="../assets/charge-icon.png")
                            .clear
                            //- .go-account(v-if="needGoAccount") 不可充值！广告主未完善账户信息。如有疑问请联系您的客户经理。
                            //-     span(@click="goUrl('/accountInfo')") 去完善信息

                        //- .charge-row(v-if="!needGoAccount")
                        .charge-row
                            .label 支付金额
                            .fl.pay-fee {{payMoney}}
                                span 元
                            
                //- .submit-btn(v-if="!needGoAccount" @click="payAction") 去充值
                .submit-btn(@click="payAction") 去充值
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'recharge',
    data () {
        return {
            nums: {},
            money: 0,
            inputFee: '',
            moneys: [1000, 3000, 5000, 8000, 10000, 20000],
            curFeeTab: 0,
            payWays: ['微信支付', '支付宝钱包'],
            curPayWay: 1
        }
    },
    computed: {
        ...mapState({
            balanceInfo: s => {
                return s.customer.balanceInfo
            },
            adUser: s => {
                return s.customer.userInfo
            }
        }),
        allFee () {
            return this.balanceInfo.balance || 0
        },
        cashFee () {
            return this.balanceInfo.cash || 0
        },
        giveFee () {
            return this.balanceInfo.give || 0
        },
        // needGoAccount () {
        //     if (this.adUser && this.adUser.id) { // 有用户信息
        //         return !this.adUser.customerId // 客户ID为0或不存在(即游客客户<=>只注册用户但未完善客户资料)
        //     }
        //     return false // 还未请求到用户信息
        // },
        payMoney () {
            if (this.curFeeTab > -1) return this.moneys[this.curFeeTab]
            else return this.inputFee ? this.inputFee.replace(/[^{\d|.}]/g,'') : '0.00'
        }
    },
    created () {
        this.$store.dispatch('customer/getAccBalance') // 账户余额
        // 如果是支付宝支付结果回调，查询结果跳到 rechargeRes 页面
        if(this.$route.query.trade_no && this.$route.query.out_trade_no) this.getAlipayRes()
    },
    methods: {
        changeIdx(type, i) {
            this[type] = i
            if(type == 'curFeeTab') this.inputFee = ''
        },
        async getAlipayRes () {
            let res = await this.fetch('/billing/api/v3/alipay/check-alipay-message', {
                trade_no: this.$route.query.trade_no,
                out_trade_no: this.$route.query.out_trade_no
            })
            if(res && res.code == this.successCode) {
                this.goUrl('rechargeRes', { ...res.data, type: 1 })
                this.$store.dispatch('customer/getAccBalance') // 更新账户余额
            } else {
                this.goUrl('rechargeRes', { type: 0 })
            }
        },
        payAction () {
            if (this.curFeeTab == -1 && this.inputFee == '') return this.messageTip('请点击选择金额或输入金额')
            const money = this.curFeeTab > -1 ? this.moneys[this.curFeeTab] : this.inputFee ? this.inputFee.slice(1) : 0
            // if (money < 100) return this.messageTip('请输入100以上的整数')
            if (this.curPayWay == -1) return this.messageTip('请选择支付方式')
            if (this.curPayWay == 0) return this.messageTip('微信支付暂不可用，请选择其他方式')

            if (this.curPayWay == 1) this.payAliPay(money)
            else this.wxPay(money)

            tzx_czcPush('finance', 'clickRechargeBtn')
        },
        async payAliPay (amount) {
            amount = amount * 1000
            const res = await this.fetch('/billing/api/v3/alipay/order-from?amount=' + amount, '', 'get')
            if (res) {
                if (res.code == this.successCode) {
                    let div = document.createElement('div')
                    div.innerHTML = res.data
                    document.body.appendChild(div)
                    div.firstChild.submit()
                }
            } else {
                this.messageTip('操作失败，请稍后重试')
            }
        },
        wxPay () {
        },
        inputFocus(e) { // 某些firfox版本不支持keyup事件
            this.curFeeTab = -1
        },
        keyupAction (e) { // 不能小数
            // let str = this.inputFee.replace(/[^\d]/g,'')
            // this.inputFee = str ? '￥' + (str - 0) : ''

            // 可以小数
            let str = this.inputFee.replace(/[^{\d|.}]/g,'')
            if (str == '.') {
               this.inputFee = '￥0.'
            } else if (str && str.split('.').length > 1) {
               let n = str.indexOf('.')
               this.inputFee = '￥' + str.slice(0, n) + '.' + str.slice(n).replace(/\./g, '').slice(0, 2)
            } else {
               this.inputFee = str ? '￥' + (str - 0) : ''
            }
        }
    }
}
</script>

